import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import React from "react";

import styles from "./invite.module.scss";

function InviteFriends(props) {
  const message = `https://cipherschools.com/resume-builder`;

  return (
    <section className={styles.container}>
      {/* <h2>✅ Invite your Friends!</h2> */}

      <p>
        Help your friends <span>build a professional resume</span> in minutes!
        💼
      </p>

      <p>
        Share the link below and make it{" "}
        <span>easier for them to land their dream job. 💫 👇🏻</span>
      </p>

      <div>
        <input value="https://cipherschools.com/resume-builder" />
        <button
          onClick={() => {
            navigator.clipboard.writeText(message);
            toast.success("Link copied");
          }}
        >
          Copy Link <Icon icon="solar:copy-bold-duotone" />
        </button>
      </div>
    </section>
  );
}

export default InviteFriends;
